<!-- Body -->
<div *ngIf="!isUnderMaintenance" class="ui basic segment">
    <app-header
        *ngIf="payrollModuleMenuService"
        title="payroll.run.payroll"
        [menuService]="payrollModuleMenuService"
    ></app-header>

    <div class="ui grid payroll-landing__grid">
        <div class="nine wide column">
            <h1 class="payroll-landing__header">{{ 'payroll.run.welcomeToHumiPayroll' | translate }}</h1>
            <p class="payroll-landing__paragraph">
                {{ 'payroll.run.getStartedByCompletingYour' | translate }}
                <a [routerLink]="['/payroll/self-onboarding/company-information']">{{
                    'payroll.run.payrollSetup' | translate
                }}</a>
                {{ 'payroll.run.andLetYourImplementationAssociateKnowOnceYoureDone' | translate }}
            </p>
            <p class="payroll-landing__paragraph">
                {{ 'payroll.run.rememberYour' | translate }}
                <a [routerLink]="['/payroll/self-onboarding/authorization-documents']">{{
                    'payroll.run.setupDocuments' | translate
                }}</a>
                {{ 'payroll.run.mustBeuploadedAndApprovedBeforeYouCanRunAlivePayrollIncludingDir' | translate }}
            </p>
        </div>
        <div class="seven wide column">
            <img class="payroll-landing__image" src="/assets/illustrations/assistance.png" />
        </div>
    </div>
</div>

<div *ngIf="isUnderMaintenance" class="ui basic login segment">
    <div class="container">
        <div class="ui raised segment" style="text-align: center">
            <div [innerHTML]="'payroll.run.scheduledMaintenanceNotice' | translate"></div>
            <ui-button type="link" [externalLink]="true" url="https://status.humi.ca">{{
                'payroll.run.viewStatus' | translate
            }}</ui-button>
        </div>
    </div>
</div>
